//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

module.exports = {
    'lercv2':'',
    'lerc-terrain':'',
    'lerc-compare':'',
    'lerc-overlay':'',
    'lerc-grid':'',
    'lerc-3d':''
};
